import getApiClient from '@/plugins/api'

export default {

    loadSurveys() {
        const self = this;
        const api = getApiClient(self.$root.$store);

        self.search = {};

        self.$store.commit('startLoading')

        self.search.page = self.page
        self.search.itemsPerPage = self.perPage
        self.search['exists[answerDate]'] = false
        self.surveys = [];

        // GET
        api.get(`/surveys`, {
            params: self.search
        })
            .then((result) => {
                self.surveys = result.data['hydra:member'];
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    changePage: function(page) {
        this.page = page
    },

    goToSurvey: function(data) {
        this.$router.push({name: 'Responder Pesquisa de Satisfação', params: {id: data.id}})
    },

    getWhatsappLink: function(item) {
        const userName = item.user.name.split(' ')[0],
          userPhone = item.user.phone,
          surveyLink = `https://minhaconta.voudetrip.com.br/#/pages/survey/${item.id}`,
          message = encodeURIComponent(`Olá ${userName}, tudo bem? Prazer sou a Talita. Notei que você fez uma compra pelo Vou de Trip mas ainda não avaliou a agência. Clique aqui para avaliar: ${surveyLink}`)

        return `https://api.whatsapp.com/send?phone=55${userPhone}&text=${message}`
    },

    sendNotification: function(item) {
        window.open(this.getWhatsappLink(item))
    }
}
